import React, { Fragment } from 'react'
import { Icon } from '@iconify/react'
import './style.css'

const StarRating = ({ rating, maxStars = 5, className = '' }) => {
    return (
        <div className={`star-rating ${className}`}>
            {[...Array(maxStars)].mapWithKey((_, i) => (
                <Fragment key={_.key} >
                    <Icon

                        icon="mdi:star"
                        className={ 'star star-filled' }
                    />
                </Fragment>
            ))}
        </div>
    )
}

export default StarRating

